// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"withCallApi_loaderWrapper__3UCb5"};